module.exports = __webpack_public_path__ + "static/media/jumoPostcardsGrid.177eb36d.png";